import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'button-footer',
  template: `
      <div class="d-flex justify-content-end m">
        <div class="d-flex my-3">
            <ng-content></ng-content>
        </div>
      </div>
          `,
  styleUrls: ['./button-footer.component.css']
})
export class ButtonFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
